import axios from "axios";
import api from "@/service/api";

/**
 * @Date: 2024-06-17 16:24:16
 * @LastEditors:ahuan
 * @description:函数说明  获取设备列表
 * @return: 返回值 Promise
 */
export function getDevList(data = '') {
    return new Promise(resolve => {
        axios({
            url: api.getDevList,
            method: "post",
            data
        })
            .then((res) => {
                /*
                * 判断请求结果
                * */
                resolve(res.data);
            }).catch((e) => {
            resolve({
                code: 0,
                errMsg: e.message
            })
        })
    })
}

/**
 * @Date: 2024-06-17 16:28:35
 * @LastEditors:ahuan
 * @description:标签列表获取
 * @return: 返回值 Promise
 */
export function getLabelList(data = '') {
    return new Promise(resolve => {
        axios({
            url: api.getLabelList,
            method: "post",
            data
        })
            .then((res) => {
                /*
                * 判断请求结果
                * */
                resolve(res.data);
            }).catch((e) => {
            resolve({
                code: 0,
                errMsg: e.message
            })
        })
    })
}

export function axiosPost(url, data) {
    return new Promise(resolve => {
        axios({
            url,
            method: "post",
            data
        })
            .then((res) => {
                /*
                * 判断请求结果
                * */
                resolve(res.data);
            }).catch((e) => {
            resolve({
                code: 0,
                errMsg: e.message
            })
        })
    })
}
const serialize = data => {
    let list = [];
    Object.keys(data).forEach(ele => {
        list.push(`${ele}=${data[ele]}`);
    });
    return list.join('&');
};
export function axiosJSONPost(url, data) {
    return new Promise(resolve => {
        axios({
            url,
            method: "post",
            data:serialize(data),
            hearder:{
                'Content-Type':'application/json'
            }
        })
            .then((res) => {
                /*
                * 判断请求结果
                * */
                resolve(res.data);
            }).catch((e) => {
            resolve({
                code: 0,
                errMsg: e.message
            })
        })
    })
}
export function axiosGet(url, data = null) {
    return new Promise(resolve => {
        axios({
            url,
            method: "get",
            params:data
        })
            .then((res) => {
                /*
                * 判断请求结果
                * */
                resolve(res.data);
            }).catch((e) => {
            resolve({
                code: 0,
                errMsg: e.message
            })
        })
    })
}
